module.exports = __webpack_public_path__ + "static/media/palco-familiar.6271b8a2.png";